module.exports = __webpack_public_path__ + "static/media/step4.df18122f.png";